var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8979168b-2d6e-477c-9f89-ff08557b834d",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12.47 13.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-3dd7d582-60a9-4225-bf7e-d93ad65d7e41{fill:url(#uuid-387400ab-a4b0-4adf-b39b-a83c1adc5573);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-387400ab-a4b0-4adf-b39b-a83c1adc5573",
    x1: -0.81,
    y1: 2.12,
    x2: 8.66,
    y2: 11.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#a040ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d640ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-ff14f859-c9e2-43d4-9319-17b3c5f25e10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-3dd7d582-60a9-4225-bf7e-d93ad65d7e41",
    d: "m11.35,4.92L3.35.3C1.86-.56,0,.52,0,2.24v9.24c0,1.72,1.86,2.79,3.35,1.93l8-4.62c1.49-.86,1.49-3.01,0-3.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8be726bb7a9d26490833641143c305b4.svg";
export { ForwardRef as ReactComponent };